import { Box, Typography } from '@mui/material'
import { PureLightThemeCaaS } from 'src/theme/schemes/PureLightTheme'
import RotoCoinIcon2 from 'src/assets/RotoCoin2.svg'
import RotoCoinIcon2White from 'src/assets/RotoCoin2white.svg'

interface CreditsValueButtonsProps {
    credits: number | string
    isCreditsAnimating: boolean
    creditsBoxRef: React.RefObject<HTMLDivElement>
    creditBoxSize?: number
    creditBoxColor?: string
    isAgentEndpoint?: boolean
    isChatBot?: boolean
    isNewRunButton?: boolean
}


const CreditsValueButtons = ({ credits, isCreditsAnimating, creditsBoxRef, creditBoxSize, creditBoxColor, isAgentEndpoint, isChatBot, isNewRunButton }: CreditsValueButtonsProps) => {
    return (
        <>
            <Box
                ref={creditsBoxRef}
                // border={"1px solid"}
                // borderColor={isCreditsAnimating ? `${PureLightThemeCaaS.colors.alpha.orange[100]}` : `${PureLightThemeCaaS.colors.alpha.white[30]}`}
                // borderRadius={1.5}
                p={0.5}
                gap={0.2}
                display="flex"
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
                sx={{
                    bgcolor: "transparent",
                    minWidth: "10px",
                    // transform: isCreditsAnimating ? "scale(1.05)" : "scale(1)",
                    transition: "all 0s ease-in-out",
                    // borderWidth: isCreditsAnimating ? "1.2px" : "1px",
                }}
            >
                {(isAgentEndpoint || isChatBot || isNewRunButton) && (
                    <>
                        {/* make the color white if creditBoxColor is true */}
                        <img src={creditBoxColor ? RotoCoinIcon2White : RotoCoinIcon2} alt="roto coin icon" width={creditBoxSize ? 18 : 12} height={"auto"} />
                    </>
                )}


                {/* <StarIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`, fontSize: 16 }} /> */}
                <Typography variant="h3" sx={{ color: `${creditBoxColor || PureLightThemeCaaS.colors.alpha.orange[100]}`, fontSize: creditBoxSize || 10 }}>
                    {credits}
                </Typography>
            </Box>
        </>
    )
}

export default CreditsValueButtons